import { createSelector } from '@reduxjs/toolkit';
import { fetchStatuses } from '../../../constants/fetchStatuses';
import { ReducerState } from '../../store.types';

export const alpacaConfigSelector = ({ alpacaConfig }: ReducerState) => alpacaConfig;
export const alpacaConfigLoadingSelector = createSelector(
  alpacaConfigSelector,
  ({ fetchStatus }) => fetchStatus === fetchStatuses.pending,
);
